var _defs, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.49387 128.44459",
    width: 268.49387,
    height: 128.4446,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g19",
    transform: "matrix(0.77978008,0,0,0.77978008,0,1.3560335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(-126.27838,-1.7389898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HBO_Max_Logo",
    d: "M 247.27,1.21 V 28.07 H 234.54 V 1.21 h -20.22 v 72.22 h 20.22 V 45.41 h 12.73 v 28.02 h 19.62 V 1.21 Z M 356.8,22.29 c -7.98,0 -14.45,6.47 -14.45,14.45 0,7.98 6.47,14.45 14.45,14.45 7.98,0 14.45,-6.47 14.45,-14.45 0,-7.98 -6.47,-14.45 -14.45,-14.45 z M 356.79,0 C 336.58,-0.01 326.25,14.86 323.7,20.87 323.72,11.85 314.84,1.22 304.44,1.21 h -33.49 v 72.23 h 31.22 c 12.59,0 21.54,-10.9 21.56,-20.25 2.87,5.89 12.84,20.62 33.05,20.61 20.23,0 36.7,-16.82 36.7,-37.06 C 393.48,16.06 377.03,0.01 356.79,0 Z m -57.22,56.61 h -9.93 V 44.4 h 9.93 c 2.89,0 5.16,2.85 5.16,6.1 0,3.25 -2.28,6.1 -5.16,6.1 z m 0.03,-27.12 h -9.93 V 17.28 h 9.93 c 2.89,0 5.16,2.85 5.16,6.1 0,3.25 -2.28,6.1 -5.16,6.1 z m 13.22,7.25 c 2.28,-0.29 6.07,-2.89 7.4,-4.55 -0.47,2.06 -0.5,8.02 0.04,10.07 -1.52,-2.35 -5.13,-5.23 -7.45,-5.52 z m 43.98,18.39 c -10.15,0 -18.38,-8.23 -18.38,-18.39 0,-10.16 8.23,-18.39 18.38,-18.39 10.15,0 18.39,8.23 18.39,18.39 0,10.16 -8.23,18.39 -18.39,18.39 z m 0,-32.84 c -7.98,0 -14.45,6.47 -14.45,14.45 0,7.98 6.47,14.45 14.45,14.45 7.98,0 14.45,-6.47 14.45,-14.45 0,-7.98 -6.47,-14.45 -14.45,-14.45 z m 0,0 c -7.98,0 -14.45,6.47 -14.45,14.45 0,7.98 6.47,14.45 14.45,14.45 7.98,0 14.45,-6.47 14.45,-14.45 0,-7.98 -6.47,-14.45 -14.45,-14.45 z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 280.38,128.8 v -28.26 c 0,-12.48 -3.41,-18.59 -13.71,-18.59 -5.81,0 -12.01,4.97 -15.42,8.07 -1.7,-5.38 -5.5,-8.07 -12.31,-8.07 -5.19,0 -10.62,3.91 -14.1,6.93 v -5.69 h -10.53 v 45.61 h 10.53 V 98.1 c 3.41,-3.02 8.36,-6.69 12.08,-6.69 4.42,0 5.12,3.42 5.12,9.13 v 28.26 h 10.53 v -28.26 c 0,-0.82 0,-1.63 -0.08,-2.37 3.41,-3.02 8.45,-6.77 12.16,-6.77 4.41,0 5.11,3.42 5.11,9.13 v 28.26 h 10.61 z",
    id: "path1",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 368.04,105.36 c 6.97,-6.62 13.26,-14.02 18.65,-22.18 h -13.26 c -3.25,5.57 -7.19,10.37 -12.02,15.36 -4.83,-4.99 -9.1,-9.79 -12.02,-15.36 h -13.26 c 5.4,8.16 11.68,15.56 18.65,22.18 -7.41,6.92 -13.93,14.79 -19.77,23.43 h 13.26 c 3.59,-6.05 7.98,-11.23 13.14,-16.51 5.17,5.28 9.55,10.46 13.14,16.51 h 13.26 c -5.84,-8.64 -12.36,-16.51 -19.77,-23.43",
    id: "path2",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 307.92,119.24 c -7.63,0 -13.82,-6.19 -13.82,-13.83 0,-7.64 6.19,-13.82 13.82,-13.82 7.63,0 13.82,6.19 13.82,13.82 0,7.63 -6.19,13.83 -13.82,13.83 m 13.71,-36.06 v 5.51 c -3.99,-4.61 -9.11,-6.75 -15.01,-6.75 -12.25,0 -22.41,10.53 -22.41,23.61 0,13.08 10.16,23.61 22.41,23.61 5.9,0 11.02,-2.14 15.01,-6.75 v 6.38 h 10.53 V 83.18 Z",
    id: "path3",
    style: {
      fill: "#ffffff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(-127.8)",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 127.81,141.07 h 3.73 c 1.29,6.45 2.96,12.32 5.02,17.6 l 5.29,-17.6 h 3.99 l 5.26,17.6 c 2.06,-5.28 3.74,-11.14 5.02,-17.6 h 3.66 c -1.77,7.67 -3.97,14.87 -6.59,21.59 h -4.36 l -5.02,-16.5 -5.06,16.5 h -4.36 c -2.62,-6.72 -4.81,-13.92 -6.59,-21.59 z",
    id: "path4",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.99,141.07 h 4.42 c 3.02,6.61 5.63,13.81 7.85,21.59 h -3.86 c -0.38,-1.46 -0.81,-2.97 -1.3,-4.52 h -10.01 c -0.38,1.22 -0.82,2.73 -1.33,4.52 h -3.63 c 2.22,-7.78 4.83,-14.98 7.85,-21.59 z m 6.06,13.71 c -1.15,-3.42 -2.45,-6.75 -3.89,-10.01 -1.4,3.06 -2.72,6.4 -3.96,10.01 z",
    id: "path5",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 185.29,144.47 h -6.89 v -3.39 h 17.36 v 3.39 h -6.89 v 18.2 h -3.59 v -18.2 z",
    id: "path6",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 201.82,161.48 c -1.69,-0.99 -2.99,-2.32 -3.93,-4.01 -0.93,-1.69 -1.4,-3.56 -1.4,-5.62 0,-2.06 0.47,-3.94 1.4,-5.62 0.93,-1.69 2.24,-3.02 3.93,-4.01 1.68,-0.99 3.6,-1.48 5.75,-1.48 1.93,0 3.69,0.43 5.27,1.3 1.59,0.87 2.88,2.05 3.88,3.56 l -3.06,1.9 c -0.67,-1.07 -1.52,-1.89 -2.58,-2.48 -1.05,-0.59 -2.22,-0.88 -3.51,-0.88 -1.4,0 -2.67,0.35 -3.81,1.05 -1.14,0.7 -2.04,1.64 -2.68,2.81 -0.64,1.18 -0.96,2.46 -0.96,3.86 0,1.4 0.32,2.68 0.96,3.86 0.64,1.18 1.53,2.11 2.68,2.81 1.14,0.7 2.41,1.05 3.81,1.05 1.29,0 2.46,-0.29 3.51,-0.88 1.05,-0.59 1.91,-1.41 2.58,-2.48 l 3.06,1.9 c -1,1.51 -2.29,2.69 -3.88,3.56 -1.59,0.86 -3.34,1.3 -5.27,1.3 -2.15,0 -4.07,-0.49 -5.75,-1.48 z",
    id: "path7",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 220.02,141.07 h 3.59 v 8.92 h 9.51 v -8.92 h 3.59 v 21.59 h -3.59 v -9.28 h -9.51 v 9.28 h -3.59 z",
    id: "path8",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 249.42,141.07 h 3.46 c 4.66,4.99 8.6,9.92 11.84,14.8 v -14.8 h 3.59 v 21.59 h -3.39 c -3.61,-5.92 -7.58,-11.22 -11.91,-15.9 v 15.9 h -3.59 z",
    id: "path9",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 277.81,161.51 c -1.7,-0.96 -3.04,-2.29 -4.03,-3.99 -0.99,-1.7 -1.48,-3.58 -1.48,-5.64 0,-2.06 0.48,-3.91 1.45,-5.62 0.97,-1.71 2.29,-3.06 3.97,-4.04 1.68,-0.98 3.57,-1.48 5.66,-1.48 2.09,0 3.91,0.49 5.61,1.46 1.7,0.97 3.03,2.31 4.01,4.01 0.98,1.7 1.46,3.58 1.46,5.64 0,2.06 -0.49,3.94 -1.48,5.64 -0.99,1.7 -2.32,3.03 -4.01,4.01 -1.69,0.98 -3.55,1.46 -5.59,1.46 -2.04,0 -3.88,-0.48 -5.57,-1.45 z m -0.89,-5.72 c 0.65,1.16 1.55,2.08 2.69,2.76 1.14,0.68 2.4,1.01 3.78,1.01 1.38,0 2.63,-0.34 3.78,-1.01 1.14,-0.68 2.04,-1.6 2.69,-2.78 0.65,-1.18 0.98,-2.47 0.98,-3.89 0,-1.42 -0.33,-2.72 -0.98,-3.91 -0.65,-1.19 -1.55,-2.12 -2.68,-2.81 -1.13,-0.69 -2.4,-1.03 -3.79,-1.03 -1.39,0 -2.67,0.35 -3.81,1.05 -1.14,0.7 -2.03,1.65 -2.68,2.84 -0.65,1.19 -0.96,2.49 -0.96,3.89 0,1.4 0.33,2.71 0.98,3.88 z",
    id: "path10",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 296.19,141.07 h 3.73 c 1.29,6.45 2.96,12.32 5.02,17.6 l 5.29,-17.6 h 3.99 l 5.26,17.6 c 2.06,-5.28 3.74,-11.14 5.02,-17.6 h 3.66 c -1.77,7.67 -3.97,14.87 -6.59,21.59 h -4.36 l -5.02,-16.5 -5.06,16.5 h -4.36 c -2.62,-6.72 -4.81,-13.92 -6.59,-21.59 z",
    id: "path11",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 338.6,141.07 h 12.77 v 3.39 h -9.18 v 5.99 h 8.38 v 3.43 h -8.38 v 8.78 h -3.59 z",
    id: "path12",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 358.98,161.51 c -1.7,-0.96 -3.04,-2.29 -4.02,-3.99 -0.99,-1.7 -1.48,-3.58 -1.48,-5.64 0,-2.06 0.48,-3.91 1.45,-5.62 0.97,-1.71 2.29,-3.06 3.98,-4.04 1.68,-0.99 3.57,-1.48 5.65,-1.48 2.08,0 3.91,0.49 5.61,1.46 1.7,0.97 3.03,2.31 4.01,4.01 0.98,1.7 1.46,3.58 1.46,5.64 0,2.06 -0.49,3.94 -1.48,5.64 -0.99,1.7 -2.32,3.03 -4.01,4.01 -1.69,0.98 -3.55,1.46 -5.59,1.46 -2.04,0 -3.88,-0.48 -5.57,-1.45 z m -0.9,-5.72 c 0.65,1.16 1.55,2.08 2.69,2.76 1.14,0.68 2.4,1.01 3.78,1.01 1.38,0 2.63,-0.34 3.78,-1.01 1.14,-0.68 2.04,-1.6 2.7,-2.78 0.65,-1.18 0.98,-2.47 0.98,-3.89 0,-1.42 -0.33,-2.72 -0.98,-3.91 -0.65,-1.19 -1.55,-2.12 -2.68,-2.81 -1.13,-0.69 -2.4,-1.03 -3.79,-1.03 -1.39,0 -2.67,0.35 -3.81,1.05 -1.14,0.7 -2.03,1.65 -2.68,2.84 -0.65,1.19 -0.96,2.49 -0.96,3.89 0,1.4 0.33,2.71 0.98,3.88 z",
    id: "path13",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 379.62,141.07 h 7.15 c 2.55,0 4.46,0.62 5.72,1.86 1.26,1.24 1.9,2.82 1.9,4.72 0,1.49 -0.36,2.79 -1.07,3.93 -0.71,1.13 -1.73,1.93 -3.06,2.39 1.97,2.55 3.63,5.44 4.96,8.68 h -4.12 c -1.26,-3.04 -2.79,-5.78 -4.59,-8.22 h -3.29 v 8.22 h -3.59 v -21.59 z m 7.35,10.18 c 1.31,0 2.3,-0.3 2.96,-0.9 0.67,-0.6 1,-1.44 1,-2.53 0,-1.09 -0.33,-1.9 -0.98,-2.51 -0.65,-0.61 -1.65,-0.92 -2.98,-0.92 h -3.76 v 6.85 h 3.76 z",
    id: "path14",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 406.23,141.07 H 419 v 3.39 h -9.18 v 5.99 h 8.38 v 3.43 h -8.38 v 8.78 h -3.59 z",
    id: "path15",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 422.63,141.07 h 7.15 c 2.55,0 4.46,0.62 5.72,1.86 1.26,1.24 1.9,2.82 1.9,4.72 0,1.49 -0.36,2.79 -1.07,3.93 -0.71,1.13 -1.73,1.93 -3.06,2.39 1.97,2.55 3.63,5.44 4.96,8.68 h -4.12 c -1.26,-3.04 -2.79,-5.78 -4.59,-8.22 h -3.29 v 8.22 h -3.59 v -21.59 z m 7.35,10.18 c 1.31,0 2.3,-0.3 2.96,-0.9 0.67,-0.6 1,-1.44 1,-2.53 0,-1.09 -0.33,-1.9 -0.98,-2.51 -0.65,-0.61 -1.65,-0.92 -2.98,-0.92 h -3.76 v 6.85 h 3.76 z",
    id: "path16",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 441.86,141.07 h 12.97 v 3.39 h -9.38 v 5.56 h 8.52 v 3.33 h -8.52 v 5.92 h 9.48 v 3.39 h -13.07 z",
    id: "path17",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 459.05,141.07 h 12.97 v 3.39 h -9.38 v 5.56 h 8.52 v 3.33 h -8.52 v 5.92 h 9.48 v 3.39 h -13.07 z",
    id: "path18",
    style: {
      fill: "#ffffff"
    }
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.4b61f518bcf24fb941628b2c9224227b.svg";
export { ForwardRef as ReactComponent };